(function ($, undefined) {
  /*============================================
    Header thin on scroll
  ==============================================*/
  $(function () {
    const $document = $(document),
      $header = $(".header"),
      HEADER_TOP_OFFSET = window.innerWidth > 992 ? 50 : 20;

    const toggleHeaderClasses = () => {
      if ($document.scrollTop() > HEADER_TOP_OFFSET) {
        $header.addClass("header_scroll");
      } else {
        $header.removeClass("header_scroll");
      }
    }

    $document.scroll(toggleHeaderClasses);
    toggleHeaderClasses();
  });

  /*============================================
  Change color on hover for header menu
 ==============================================*/
  $(function () {
    const $headerNavBar = $(".header").find('.navbar-nav:not(.navbar-nav_right)'),
      $navItem = $headerNavBar.find('.nav-item'),
      notExistNavElementsAndIsDesktop = !$headerNavBar.length && !$navItem.length && window.innerWidth <= 991;

    if (notExistNavElementsAndIsDesktop) return;

    $navItem.hover (
      function () { $navItem.not(this).addClass("gray"); },
      function () { $navItem.removeClass("gray"); }
    );
  });

  /*============================================
  Make body static when header menu is open (mob)
  ==============================================*/
  $(function () {
    const $navbarToggler = $('.navbar-toggler'),
      $body = $('body');

    if (!$navbarToggler.length) return;

    $navbarToggler.on('click', function () {
      const $this = $(this);

      $this.hasClass('collapsed') ? $body.css({'overflow-y': 'visible'}) : $body.css({'overflow-y': 'hidden'});
    });
  });

  /*============================================
    Swiper Sliders
  ==============================================*/
  $(function () {
    // Reviews Swiper
    const $reviewsSwiper = $('.reviews-swiper');

    if ($reviewsSwiper.length) {
      $reviewsSwiper.each(function () {
        const everySlider = $(this)[0];

        const animateReviewText = (slider) => {
          const indexOfCurrentSlide = slider.realIndex,
            currentSlide = slider.slides[indexOfCurrentSlide],
            currentSlideReviewText = currentSlide.querySelector('.js-text-animation'),
            splitText = new SplitType(currentSlideReviewText, {types: "words", tagName: "span"}),
            words = currentSlideReviewText.querySelectorAll('.word');

          const animationTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: currentSlide,
              start: "top 80%",
              end: "top center",
              scrub: true
            }
          });

          animationTimeline.from(words, {opacity: 0.2, duration: 0.2, stagger: {each: 1}});
        }

        new Swiper(everySlider, {
          spaceBetween: 25,
          grabCursor: true,
          loop: true,
          pagination: {
            el: ".reviews-swiper .swiper-pagination",
            clickable: true
          },
          navigation: {
            nextEl: ".reviews-swiper .swiper-button-next",
            prevEl: ".reviews-swiper .swiper-button-prev",
          },
          on: {
            afterInit: animateReviewText,
            slideChange: animateReviewText
          }
        });
      });
    }

    // Partners Swiper
    const $partnersSwiper = $('.partners-swiper');

    if ($partnersSwiper.length) {
      new Swiper($partnersSwiper[0], {
        slidesPerView: 2.5,
        speed: 5000,
        loop: true,
        spaceBetween: 25,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        breakpoints: {
          575: {
            slidesPerView: 3
          },
          991: {
            slidesPerView: 5,
            spaceBetween: 55,
          },
          1200: {
            slidesPerView: 6
          },
          1400: {
            slidesPerView: 7,
            spaceBetween: 80,
          }
        },
      });
    }

    // Content Swiper with Clickable Links
    const $contentSwiper = $('.content-swiper'),
      $contentSwiperLinks = $('.js-content-swiper-link');

    // Set Active Button on slide change event
    const setActiveButton = function (slider) {
      const $currentSlide = $(slider.slides[slider.activeIndex]),
        $currentSlideData = $currentSlide.data('slide');

      $contentSwiperLinks.removeClass('active');
      $('#' + $currentSlideData).addClass('active');
    }

    // Change slide by link click
    if ($contentSwiper.length) {
      const contentSwiper = new Swiper($contentSwiper[0], {
        slidesPerView: 1,
        spaceBetween: 30,
        grabCursor: true,
        loop: true,
        navigation: {
          nextEl: ".content-swiper-button-next",
          prevEl: ".content-swiper-button-prev",
        },
        pagination: {
          el: ".content-swiper-pagination",
          clickable: true
        },
        on: {
          slideChange: setActiveButton,
        }
      });

      if ($contentSwiperLinks.length) {
        $contentSwiperLinks.on('click', function (e) {
          e.preventDefault();
          const linkIndex = $contentSwiperLinks.index(this);

          $contentSwiperLinks.removeClass('active').eq(linkIndex).addClass('active');
          contentSwiper.slideToLoop(linkIndex);
        });
      }
    }

    // Customer Stories Swiper
    const $customerStoriesSwiper = $('.customer-stories-swiper');

    if ($customerStoriesSwiper.length) {
      new Swiper($customerStoriesSwiper[0], {
        slidesPerView: 1,
        spaceBetween: 25,
        grabCursor: true,
        autoHeight: true,
        navigation: {
          nextEl: ".customer-stories-swiper-button-next",
          prevEl: ".customer-stories-swiper-button-prev",
        },
        pagination: {
          el: ".customer-stories-swiper-pagination",
          clickable: true
        },
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            autoHeight: false
          },
          991: {
            slidesPerView: 3
          }
        }
      });
    }

    // Badges Swiper
    const $badgesSwiper = $('.badges-swiper'),
      $badgesSwiperWrapper = $badgesSwiper.find('.swiper-wrapper'),
      $badgesSwiperSlide = $badgesSwiper.find('.swiper-slide'),
      hasInsufficientSlidesForLoopOnMobile = $badgesSwiperSlide.length <= 6 && window.innerWidth <= 991;

    // Clone slides for autoplay enabling on Mobile
    if (hasInsufficientSlidesForLoopOnMobile) {
      $badgesSwiperWrapper.append($badgesSwiperSlide.clone());
    }

    if ($badgesSwiper.length) {
      new Swiper($badgesSwiper[0], {
        slidesPerView: 'auto',
        spaceBetween: 25,
        loop: true,
        speed: 5000,
        lazy: false,
        centerInsufficientSlides: true,
        centeredSlides: true,
        freeMode: false,
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        breakpoints: {
          991: {
            centeredSlides: false,
            autoplay: false,
            loop: false,
            centerInsufficientSlides: false,
          },
          1400: {
            centeredSlides: false,
            centerInsufficientSlides: false,
            autoplay: false,
            loop: false,
            spaceBetween: 70
          }
        }
      });
    }
  });

  /*============================================
  Submit text for Subscribe Form
  ==============================================*/
  $(function () {
    window.addEventListener('message', event => {
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
        const formSubmitText = $('.n-hs-form .legal-consent-container p').html(),
          underFormSubmitParagraph = $('.n-hs-form__submit');

        if (formSubmitText && underFormSubmitParagraph) {
          underFormSubmitParagraph.html(formSubmitText);
        }
      }
    });
  });

  /*============================================
   GSAP Animation
  ==============================================*/
  $(function () {
    gsap.registerPlugin(ScrollTrigger);

    const runAnimation = (selector) => {
      gsap.utils.toArray(selector).forEach((el) => {
        const from = {
          x: parseFloat(el.dataset.x) || 0,
          y: parseFloat(el.dataset.y) || 0,
          opacity: 0
        };

        const duration = parseFloat(el.dataset.duration) || 0.6,
          delay = parseFloat(el.dataset.delay) || 0,
          start = el.dataset.start || 'top 80%',
          end = el.dataset.end || 'top center';

        gsap.fromTo(el, from, {
          x: 0, y: 0, opacity: 1,
          duration,
          delay,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start,
            end,
            toggleActions: 'play none none reverse'
          }
        });
      });
    };

    // Always animate
    runAnimation('.js-animate');

    // Animate only on desktop
    if (window.innerWidth > 991) {
      runAnimation('.js-animate-desktop');
    }
  });

  /*============================================
  Helpers
  ==============================================*/
  $.fn.isInViewport = function (OFFSET = 0) {
    const $this = $(this),
      elementTop = $this.offset().top + OFFSET,
      elementBottom = elementTop + $this.outerHeight(),
      viewportTop = $(window).scrollTop(),
      viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
})(jQuery);


